import React from 'react';
import Highlighter, { HighlighterProps } from 'react-highlight-words';

import styles from './BaseHighlighter.module.less';

export default function BaseHighlighter(props: HighlighterProps) {
  const {
    autoEscape = true,
    highlightClassName = styles.highlightText,
    ...rest
  } = props;

  return (
    <Highlighter
      {...rest}
      autoEscape={autoEscape}
      highlightClassName={highlightClassName}
    />
  );
}
